import { cn } from '@sola/ark-core/utils/helpers.js';
import { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.js';

import { CommitmentAvatarTooltip } from '../../atoms/commitment-avatar-tooltip/commitment-avatar-tooltip';
import {
  CommitmentAvatar,
  CommitmentAvatarProps,
} from '../../atoms/commitment-avatar/commitment-avatar';

interface CommitmentAvatarGroupProps {
  commitments: GraphQLCommitment[];
  layout?: 'spaced' | 'stacked';
  itemsToShow?: number;
  purpose?: CommitmentAvatarProps['purpose'];
  size?: CommitmentAvatarProps['size'];
  tooltipMessage?: string;
  usePortal?: boolean;
}

export const CommitmentAvatarGroup = ({
  commitments,
  layout = 'stacked',
  itemsToShow = 3,
  purpose,
  size,
  tooltipMessage,
  usePortal = true,
}: CommitmentAvatarGroupProps) => {
  const items = commitments.slice(0, itemsToShow);
  return (
    <div
      className={cn({
        'flex flex-row gap-comfy-xs': layout === 'spaced',
        'flex items-center gap-snug-md': layout === 'stacked',
      })}
    >
      <div
        className={cn('flex flex-row', {
          'gap-snug-xl': layout === 'spaced',
        })}
      >
        {items.map((commitment, index) => {
          const shouldShowRemaining =
            index === itemsToShow - 1 && commitments.length > itemsToShow;
          /** NOTE: plus one to account for this item plus remaining */
          const remainingCount = commitments.length - itemsToShow + 1;

          return (
            <CommitmentAvatar
              key={commitment.internalId}
              {...(!shouldShowRemaining
                ? { commitment }
                : { text: `+${remainingCount}` })}
              size={size}
              isStacked={index < items.length - 1 && layout === 'stacked'}
              purpose={purpose}
            />
          );
        })}
      </div>
      {/* TODO: this is a specific tooltip being used, should this be more generic
      and allow a translation to be passed in? or is this a place where we make it more Composable? */}
      {tooltipMessage && (
        <CommitmentAvatarTooltip
          translation={tooltipMessage}
          usePortal={usePortal}
        />
      )}
    </div>
  );
};
